const examples = [
  {
    name: 'Enhanced Due Diligence sample',
    path: "/data/enhancedDueDiligence/WASP_SAMPLE_EDD.pdf"
  }
]

export default examples;